import { FC } from "react";

import { DISTANCE_DROPDOWN_ID } from "../const";
import classes from "./dropdown.scss";

interface IDropdownProps {
  options: {
    value: string;
    label: string;
  }[];
  onChange: (val: string) => void;
  value: string;
  isOpen: boolean;
}

const Dropdown: FC<IDropdownProps> = ({ options, onChange, value, isOpen }) => {
  return (
    <ul
      className={classes.root}
      id={DISTANCE_DROPDOWN_ID}
      aria-hidden={!isOpen}
    >
      {options?.map((option) => {
        return (
          <li key={option.value} className={classes.option}>
            <button
              type="button"
              onClick={() => {
                onChange(option.value);
              }}
              data-t2={option.value}
              data-t1="distance_dropdown_button"
              disabled={value === option.value}
              tabIndex={isOpen && value !== option.value ? 0 : -1}
            >
              {option.label}
            </button>
          </li>
        );
      })}
    </ul>
  );
};

export default Dropdown;
